import ApiClient from './ApiClient';

class UpcomingScheduledMessages extends ApiClient {
  constructor() {
    super('upcoming_scheduled_messages', {
      accountScoped: true,
    });
  }
}

export default new UpcomingScheduledMessages();